export enum ActionTypes {
  SET_PROJECT_SUMMARY = 'quote/SET_PROJECT_SUMMARY',
  EDIT_TABLE_CELL = 'quote/EDIT_TABLE_CELL',
  SET_COMPANY_DATA = 'quote/SET_COMPANY_DATA',
  SET_COMPANY_DATA_FIELD = 'quote/SET_COMPANY_DATA_FIELD',
  SET_CLIENT_DATA = 'quote/SET_CLIENT_DATA',
  SET_CLIENT_DATA_FIELD = 'quote/SET_CLIENT_DATA_FIELD',
  SET_DISCOUNT = 'quote/SET_DISCOUNT',
  SET_TAX = 'quote/SET_TAX',
  SET_QUOTE_DATA = 'quote/SET_QUOTE_DATA',
  SET_GROUP_NAME = 'quote/SET_GROUP_NAME',
  ADD_GROUP = 'quote/ADD_GROUP',
  ADD_ITEM = 'quote/ADD_ITEM',
  ADD_UNSORTED_GROUP = 'quote/ADD_UNSORTED_GROUP',
  DELETE_GROUP = 'quote/DELETE_GROUP',
  SET_DISABLED_TABLE_OPTIONS = 'quote/SET_DISABLED_TABLE_OPTIONS',
  SET_NOTES = 'quote/SET_NOTES',
  SET_EXTENDED_NOTES = 'quote/SET_EXTENDED_NOTES',
  ADD_GROUP_IMAGE = 'quote/ADD_GROUP_IMAGE',
  REMOVE_GROUP_IMAGE = 'quote/REMOVE_GROUP_IMAGE',
  UNDO = 'quote/UNDO',
  REDO = 'quote/REDO',
  UPDATE_PROPOSAL_SUCCESS = 'UPDATE_PROPOSAL_SUCCESS',
  UPDATE_PROPOSAL_ERROR = 'UPDATE_PROPOSAL_ERROR',
  REMOVE_ITEM = 'REMOVE_ITEM',
  DELETE_PROPOSAL_SUCCESS = 'DELETE_PROPOSAL_SUCCESS',
  SET_EDITED = 'quote/SET_EDITED',

  SET_OWNER_ID = 'quote/SET_OWNER_ID',

  PROPOSAL_START_REQUEST = 'quote/PROPOSAL_START_REQUEST',
  PROPOSAL_START_SUCCESS = 'quote/PROPOSAL_START_SUCCESS',
  PROPOSAL_START_ERROR = 'quote/PROPOSAL_START_ERROR',

  PROPOSAL_MATERIALS_REQUEST = 'quote/PROPOSAL_MATERIALS_REQUEST',
  PROPOSAL_MATERIALS_SUCCESS = 'quote/PROPOSAL_MATERIALS_SUCCESS',
  PROPOSAL_MATERIALS_ERROR = 'quote/PROPOSAL_MATERIALS_ERROR',

  PROPOSAL_GENERATE_REQUEST = 'quote/PROPOSAL_GENERATE_REQUEST',
  PROPOSAL_GENERATE_SUCCESS = 'quote/PROPOSAL_GENERATE_SUCCESS',
  PROPOSAL_GENERATE_ERROR = 'quote/PROPOSAL_GENERATE_ERROR',

  RESET_PROPOSAL_DRAFT = 'quote/RESET_PROPOSAL_DRAFT',
}
